import React, { Component } from "react";
import {siteContext} from "../tools/toolbox";

class DefaultPage extends Component {
  componentDidMount() {
    const redirect = siteContext().accessToken
      ? '/dashboard'
      : '/login';

    window.location.replace(redirect);
  }

  render() {
        return (
            <div>
              This page does not exist
            </div>
        );
    }
}

export default DefaultPage;